
<div class="min-h-screen flex flex-column surface-ground">
 <!-- <app-nav-bar></app-nav-bar>  -->
 <app-nav-bar-flowdy2></app-nav-bar-flowdy2> 
<router-outlet>
</router-outlet>
<app-test-environment-footer *ngIf="!isProdEnv"></app-test-environment-footer>

</div>